import React from "react";

export default function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative pt-36 pb-14 md:pt-44 md:pb-20 bg-[#1a2b4a] overflow-hidden">
      {/* decorative layers */}
      <div className="absolute inset-0 opacity-[0.08] bg-[radial-gradient(circle_at_20%_20%,#ffffff_0,transparent_45%)]" />
      <div className="absolute -right-20 -top-24 w-96 h-96 rounded-full bg-[#b8935a]/10 blur-3xl" />
      <div className="absolute -left-24 bottom-0 w-80 h-80 rounded-full bg-white/5 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className={image ? "lg:col-span-8" : "lg:col-span-12"}>
          {eyebrow && (
            <p className="text-xs uppercase tracking-[0.3em] text-[#e6c98d] mb-4 animate-fade-up">
              {eyebrow}
            </p>
          )}
          <h1 className="font-serif text-4xl md:text-6xl font-bold text-white leading-[1.05] animate-fade-up">
            {title}
          </h1>
          <div className="w-16 h-[3px] bg-[#b8935a] mt-6 animate-fade-up" />
          {subtitle && (
            <p className="mt-6 max-w-2xl text-white/70 text-base md:text-lg leading-relaxed animate-fade-up">
              {subtitle}
            </p>
          )}
        </div>

        {image && (
          <div className="lg:col-span-4 flex justify-center lg:justify-end animate-scale-in">
            <div className="relative">
              <div className="absolute -inset-3 border border-[#b8935a]/40 rounded-lg translate-x-3 translate-y-3" />
              <img
                src={image}
                alt="T.P. Sreenivasan"
                className="relative w-44 h-52 md:w-52 md:h-64 object-cover rounded-lg shadow-2xl"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
